<template>
    <div class="default-genre-countries">
        <p v-if="hasOnlyGenres" class="results">Latest <b class="genres-excerpt"></b> releases.&nbsp;&nbsp;&nbsp;&nbsp;<a @click="showFilters = true" class="text-underline">change settings</a></p>
        <p v-if="hasOnlyCountries" class="results">Latest releases from artists and labels listed in <b class="countries-excerpt"></b>&nbsp;&nbsp;&nbsp;&nbsp;<a @click="showFilters = true" class="text-underline">change settings</a></p>
        <p v-if="hasBoth" class="results">Latest <b class="genres-excerpt"></b> releases form artists and labels listed in <b class="countries-excerpt"></b>&nbsp;&nbsp;&nbsp;&nbsp;<a @click="showFilters = true" class="text-underline">change settings</a></p>
        <p v-if="hasNone" class="results">You have no preffered genres and countries set.&nbsp;&nbsp;&nbsp;&nbsp;<a @click="showFilters = true" class="text-underline">change settings</a></p>

        <div :id="eid">
            <transition name="page-overlay">
                <div class="page-overlay filters" v-if="showFilters">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="btn-close button button-center" @click="closeFilters()">
                                    <i class="iconify" data-icon="ic:outline-chevron-left" data-inline="false"></i>
                                </div>
                            </div>
                            <div class="col-xs-12 content">
                                <input type="text" class="search-filters" placeholder="Search for genres and countries" v-model="search">
                                <i class="iconify" data-icon="ic:sharp-search"></i>

                                <p class="title text-right">
                                    <span class="pull-left"><b>Genres</b> ({{ totalGenres }}/{{ this.filters.genres.length }})</span>
                                    <a @click="toggleFilterAll('genres', false)">select all</a>&nbsp;
                                    <a @click="toggleFilterAll('genres', true)">select none</a>
                                </p>
                                <ul class="list genres">
                                    <li v-for="(g,i) in filters.genres" class="button" @click="toggleFilter('genres', i)" :class="{'selected' : isSelectedFilter('genres', i) }">{{ g.name }}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="row m-t-12">
                            <div class="col-xs-12 content">
                                <p class="title text-right">
                                    <span class="pull-left"><b>Countries</b> ({{ totalCountries }}/{{ this.filters.countries.length }})</span>
                                    <a @click="toggleFilterAll('countries', false)">select all</a>&nbsp;
                                    <a @click="toggleFilterAll('countries', true)">select none</a>
                                </p>

                                <ul class="list countries">
                                    <li v-for="(cg,i) in filters.countries" class="button col-xs-4" @click="toggleFilter('countries', i)" :class="{'selected' : isSelectedFilter('countries', i) }">{{ cg.name }}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 text-center m-t-12">
                                <div class="btn btn-default btn-outline button btn-save" @click="closeFilters()">CONFIRM SELECTION</div>
                            </div>
                        </div>                      
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'limitExcerptCountries': {default: 3},
        'limitExcerptGenres': {default: 3},
        'expandable': {default: false}
    },

    data() {
        return {
            eid: "filter_overlay_"+ Math.random().toString(36).substr(2, 9),
            loaded: false,
            filters: false,
            countryGroups: false,
            showFilters: false,
            search: '',
            reqData:{
                countries: [],
                genres: [],
            },

            formattedFilters: {
                comma_separated_genres: "",
                comma_separated_countries: ""
            },
        }
    },

    mounted() {
        $(`#${this.eid}`).appendTo(".page-content");

        // initialize stuff and arrays
        this.countryGroups = $.extend({}, App.countryGroups);
        this.filters = $.extend(true, {}, App.filters.raw);

        this.filters.countries.sort((a, b) => {
            var aName = a.name.toLowerCase();
            var bName = b.name.toLowerCase(); 
            return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
        });

        this.filters.genres.sort((a, b) => {
            var aName = a.name.toLowerCase();
            var bName = b.name.toLowerCase(); 
            return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
        });

        this.loaded = true;
        this.getStringFilters();
    },

    methods: {
        closeFilters(){
            setTimeout(() => {
                this.showFilters = false;
            }, 350);
        },

        toggleFilter(type, index){
            this.filters[type][index].status = this.filters[type][index].status ? 0 : 1;
        },

        toggleFilterAll(type, state){
            if (type == 'genres'){
                if(state){
                    $.each(this.filters[type], (i, li) => { setTimeout(() => { this.filters[type][i].status = 0; }, i * 5); });
                }else{
                    $.each(this.filters[type], (i, li) => { setTimeout(() => { this.filters[type][i].status = 1; }, i * 5); });
                }
            }

            if (type == 'countries'){
                if(state){
                    $.each(this.filters[type], (i, li) => { this.filters[type][i].status = 0; });
                }else{
                    $.each(this.filters[type], (i, li) => { this.filters[type][i].status = 1; });
                }
            }
        },

        isSelectedFilter(type, index){
            return this.filters[type][index].status;
        },

        showDefaultGenreModal() {
            this.$root.$emit('showDefaultGenreModal');
        },

        showDefaultRegionModal() {
            this.$root.$emit('showDefaultRegionModal');
        },

        getStringFilters() {
            this.formattedFilters = this.formatFilterData();
            this.loaded = true;
            this.$nextTick(() => {
                this.excerptCountries();
                this.excerptGenres();
            });
        },

        excerptCountries(minify = true) {
            var vue = this;
            var content = this.formattedFilters.comma_separated_countries;

            if (minify){
                var cArray = content.split(", ");
                var cExcerpt = content.split(", ").splice(0, vue.limitExcerptGenres);
     
                if (cArray.length - cExcerpt.length > 0){ 
                    content = cExcerpt.join(", ") + (this.expandable ? ` ... <code class="pointer show-more">(${cArray.length - cExcerpt.length} more)</code>` : ` ...`);
                }

                $('.default-genre').one('click', '.countries-excerpt code.show-more', () => {
                    vue.excerptCountries(false);
                })                
            }else{
                content = content + `<code class="pointer show-less">(show less)</code>`;
                
                $('.default-genre').one('click', '.countries-excerpt code.show-less', () => {
                    vue.excerptCountries();
                });                 
            }

            $('.countries-excerpt').html( content );
        },

        excerptGenres(minify = true) {
            var vue = this;
            var content = this.formattedFilters.comma_separated_genres;

            if (minify){
                var cArray = content.split(", ");
                var cExcerpt = content.split(", ").splice(0, vue.limitExcerptGenres);
     
                if (cArray.length - cExcerpt.length > 0){ 
                    content = cExcerpt.join(", ") + (this.expandable ? ` ... <code class="pointer show-more">(${cArray.length - cExcerpt.length} more)</code>` : ` ...`);
                }

                $('.default-genre').one('click', '.genres-excerpt code.show-more', () => {
                    vue.excerptGenres(false);
                })                
            }else{
                content = content + `<code class="pointer show-less">(show less)</code>`;
                
                $('.default-genre').one('click', '.genres-excerpt code.show-less', () => {
                    vue.excerptGenres();
                });                 
            }

            $('.genres-excerpt').html( content );
        },

        formatFilterData(){
            var cArray = [];
            $.each(this.filters.countries, function(i, elem){
                if (elem.status > 0) cArray.push(elem.name);
            });

            var gArray = [];
            $.each(this.filters.genres, function(i, elem){
                if (elem.status > 0) gArray.push(elem.name);
            });
 
            return {
                comma_separated_countries: cArray.join(", "),
                comma_separated_genres: gArray.join(", ")
            }
        },
    },

    computed: {
        totalGenres(){
            return $.grep(this.filters.genres, function(g, i) { return g.status != 0 }).length;
        },

        totalCountries(){
            return $.grep(this.filters.countries, function(c, i) { return c.status != 0 }).length;
        },

        hasOnlyGenres() {
            return this.formattedFilters.comma_separated_genres.length
                && !this.formattedFilters.comma_separated_countries.length
            ;
        },

        hasOnlyCountries() {
            return this.formattedFilters.comma_separated_countries.length
                && !this.formattedFilters.comma_separated_genres.length
            ;
        },

        hasBoth() {
            return this.formattedFilters.comma_separated_genres.length
                && this.formattedFilters.comma_separated_countries.length
            ;
        },

        hasNone() {
            return !this.formattedFilters.comma_separated_genres.length
                && !this.formattedFilters.comma_separated_countries.length
             ;
        },
    },

    watch:{
        showFilters(){
            this.search = '';

            if (this.showFilters == false){
                $('.page-content').addClass('hasFooter');
                
                this.reqData.countries = [];
                $.each(this.filters.countries, (i, c) => {
                    if ( c.status ) this.reqData.countries.push(c.id);
                })

                this.reqData.genres = [];
                $.each(this.filters.genres, (i, g) => {
                    if ( g.status ) this.reqData.genres.push(g.id);
                })
                
                this.$parent.$emit('updateFilters', this.reqData); 
                this.getStringFilters();

                if (App.allowGtag) gtag('event', 'filters_save', {
                    'event_category' : 'search',
                    'event_label' : `Change search filters`
                });
            }else{
                $('.page-content').removeClass('hasFooter');

                if (App.allowGtag) gtag('event', 'filters_open', {
                    'event_category' : 'search',
                    'event_label' : `Open search filters`
                });
            }       
        },

        search(){
            var qString = this.search;
            $('.page-overlay.filters .list li').each((i,e) => {
                if ($(e).text().toLowerCase().indexOf( qString.toLowerCase() ) == -1 && qString.length){
                    $(e).hide();
                }else{
                   $(e).show();
                }
            })
        }
    },

    beforeDestroy() {
        this.$root.$off(['userUpdatedFilters']);
        $(`#${this.eid}`).remove();
    }

}
</script>
